
import { SendEmailResult } from "@/lib/api/clients/AWSClient";
import { handleErrorServer, ServerError } from "@/lib/api/errors/ErrorHandler";
import { sendEmails as sendEmailsApi } from "@/lib/api/clients/AWSClient";

const MAX_RECIPIENTS = 5;

// Send emails to recipients
export async function sendEmails(
  eventId: string,
  emailTemplateId: string,
  language: string,
  recipients: string[],
  // Optional: id of an example guest whose data fills the template
  // variables in the test send (full pipeline render, delivered to
  // `recipients`). Omit for the raw, unsubstituted test send.
  sampleGuestId?: string
): Promise<SendEmailResult | ServerError> {

  if (!eventId) {
    return handleErrorServer("Event ID is not set in cookies.");
  }

  if (!recipients || recipients.length === 0) {
    return handleErrorServer("Recipients list cannot be empty.");
  }

  if (recipients.length > MAX_RECIPIENTS) {
    return handleErrorServer(
      `Cannot send emails to more than ${MAX_RECIPIENTS} recipients at once. Provided: ${recipients.length}`
    );
  }

  if (!emailTemplateId) {
    return handleErrorServer("Email template ID is required.");
  }

  if (!language) {
    return handleErrorServer("Language is required.");
  }

  try {
    const response = await sendEmailsApi(
      eventId,
      emailTemplateId,
      language,
      recipients,
      sampleGuestId,
    );

    return response;
  } catch (error) {
    return handleErrorServer(error);
  }
}
